export const flags = {
  logQueries: false,
  logResourceView: false,
  logStateProviders: false,
  enableAds: !['1', 'true'].includes(process.env.REACT_APP_DISABLE_ADS ?? ''),
  enableTracking: !['1', 'true'].includes(process.env.REACT_APP_DISABLE_TRACKING ?? ''),
};
